import Color from "color";

import { buildUiPalettes } from "../ui/utils/uiPalette";
import { colorMap } from "./constants";
import type { UseThemeType } from "./types";
import { isDark } from "./utils";

const primaryColour = "#14435B";
const secondaryColour = "#1b678e";
const accent = Color(primaryColour).lighten(0.2);
const secondaryAccent = Color(secondaryColour).lighten(0.6).fade(0.8);
const shouldBeWhiteOnPrimary = isDark(Color(primaryColour));
const shouldBeWhiteOnSecondary = isDark(Color(secondaryColour));

export const defaultTheme: UseThemeType = {
  sizes: {
    isMobile: false,
    isTablet: false,
    isComputer: true,
    isLargeComputer: false,
    width: 1024,
  },
  primaryColour,
  secondaryColour,
  accent: accent.hex(),
  secondaryAccent: secondaryAccent.hex(),
  shouldBeWhiteOnSecondary,
  shouldBeWhiteOnPrimary,
  shouldBeWhiteOnAccent: isDark(accent),
  shouldBeWhiteOnSecondaryAccent: isDark(secondaryAccent),
  boxShadow: "0.5px 0.5px 2.5px 1px #C0C0C0",
  colors: buildUiPalettes({
    colorMap,
    primaryColour,
    secondaryColour,
    shouldBeWhiteOnPrimary,
    shouldBeWhiteOnSecondary,
  }),
  fontFamily: {
    h1: "Inter",
    h2: "Inter",
    h3: "Inter",
    h4: "Inter",
    h5: "Inter",
    body: "Inter",
  },
};
